import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRepatriationsTransactionsHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRepatriationsTransactionHistory',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      transactionId: payload.params.transactionId,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchRepatriationsTransactionsHistory;
